/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `"Pinyon Script", cursive;`,
  body: `"Baskervville", serif;`,
  body_lv2: `"Baskervville", serif;`,
  name: `"Pinyon Script", cursive;`,
  fullName: `"Baskervville", serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    textAlign: 'center',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    textAlign: 'center',
  },
  body_lv2: {
    fontFamily: 'body_lv2',
    fontSize: 'body_lv2',
    fontWeight: 'body_lv2',
    fontStyle: 'var(--fontItalic-body_lv2)',
    textAlign: 'center',
  },
  nameProps: {
    fontFamily: 'name',
    fontSize: 'name',
    fontWeight: 'name',
    fontStyle: 'var(--fontItalic-name)',
  },
  fullNameProps: {
    fontFamily: 'fullName',
    fontSize: 'fullName',
    fontWeight: 'fullName',
    fontStyle: 'var(--fontItalic-fullName)',
  },
};

export const PRIMARY_BUTTON_PROPS = {
  color: 'btnColorText',
  size: 'sm',
  fontFamily: 'body',
  fontWeight: 'normal',
  bgColor: 'bgAlternative',
  letterSpacing: '2px',
  textTransform: 'uppercase',
  boxShadow: 'xl',
  _hover: { opacity: '0.8' },
};
export const SECONDARY_BUTTON_PROPS = {
  ...PRIMARY_BUTTON_PROPS,
  bgColor: 'rgb(240 237 230 / 23%)',
};
